:host {
  @include reset-host;
}

:host .hub-youth-card {
  display: flex;
  gap: rem(32);
  margin-top: 24px;
  padding: 24px;

  border: 1px solid $color-purple-light;
  border-radius: rem(16);

  @include mq('max', 'md') {
    flex-direction: column;
    align-items: center;
    margin-top: 12px;
    padding: 16px;

    text-align: center;
  }
}

:host .text-wrapper {
  flex: 1;

  @include mq('max', 'md') {
    margin-bottom: rem(16);
  }
}

:host .button {
  display: block;
}
